import React, { useState, useEffect, useRef } from 'react';

import { useHistory, useParams } from "react-router-dom";
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel'
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../hooks/snackBar';
import {
    cadastrarUsuarioSeller,
    atualizarUsuarioSeller,
    detalheUsuarioSeller,
    inativarUsuarioSeller
} from '../../../../services/http/SellerAdminstradorService/usuarioSellerService'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import { cargos } from '../../../../services/cargosseller'
import services from '../../../../services';
import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const PerfilSellerFormUsuario = () => {

    const { addSnackBar } = useSnackBar();
    const history = useHistory();
    const { id } = useParams();
    const { idSeller } = services.storage.getUser();
    const [voltou, setVoltou] = useState(false);
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [senhaCorreta, setSenhaCorreta] = useState(true);
    const [senhaFormatoCorreto, setSenhaFormatoCorreto] = useState(true);
    const [idUsuarioSeller, setIdUsuarioSeller] = useState(null);
    const [senha, setSenha] = useState("");
    const stateRef = useRef();
    stateRef.current = voltou;
    const [usuario, setUsuario] = useState({
        nome: "",
        email: "",
        telefone: "",
        cargo: "",
        senha: "",
        receberNotificacao: false,
        id: ""
    });


    const changeUsuario = (value, propertie) => {
        setUsuario((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const validarFomatoSenha = () => {
        var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&_*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
        var passou = regularExpression.test(usuario?.senha);
        setSenhaFormatoCorreto(passou);

        if (senha != usuario.senha) {
            setSenhaCorreta(false);
            return false;
        }
        setSenhaCorreta(true);
        return true;
    }

    const conferirSenha = () => {
        if (!(!usuario.senha && idUsuarioSeller)) {
            return validarFomatoSenha();
        }

        return true;
    }

    const carregarDetalhesUsuarioSeller = (id) => {
        trackPromise(
            detalheUsuarioSeller(id)
                .then(res => {
                    if (res.data) {
                        setUsuario(res.data);
                    } else {
                        if (id) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do usuário', info: 'warning', open: true });
                        }
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do usuário', info: 'error', open: true });
                })
        )
    }

    const submitUsuarioSeller = () => {
        if (!validarForm() && conferirSenha()) {
            removerMascaraTelefone();
            if (idUsuarioSeller == null || idUsuarioSeller == undefined) {
                trackPromise(
                    cadastrarUsuarioSeller(usuario, idSeller)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                setIdUsuarioSeller(res.data);
                                voltar();
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar usuário', info: 'error', open: true });
                        })
                )
            }
            else {
                usuario.id = idUsuarioSeller;
                trackPromise(
                    atualizarUsuarioSeller(usuario)
                        .then(res => {
                            if (res.fail == null) {
                                addSnackBar({ message: 'Usuário atualizado com sucesso', info: 'success', open: true });
                                voltar();
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });
                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao editar usuário', info: 'error', open: true });
                        })
                )
            }

        }
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!usuario?.nome) isInvalidForm = true;
        if (!usuario?.email) isInvalidForm = true;
        if (usuario?.senha?.length < 8) isInvalidForm = true;
        if (!usuario?.telefone) isInvalidForm = true;
        if (!senhaCorreta) isInvalidForm = true;
        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const inativarUsuario = () => {
        if (idUsuarioSeller != null || idUsuarioSeller != undefined) {
            trackPromise(
                inativarUsuarioSeller(idUsuarioSeller)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Usuário inativado com sucesso', info: 'success', open: true });
                            voltar();
                        } else {
                            addSnackBar({ message: 'Não foi inativar usuário', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar usuário', info: 'error', open: true });
                    })
            )
        }
    }

    useEffect(() => {
        if (id != null) {
            setIdUsuarioSeller(id);
            carregarDetalhesUsuarioSeller(id);
        }
    }, []);

    const voltar = () => {
        history.push('/seller/usuario');
    }

    const setConfirmarSenha = (value) => {
        setSenha(value);
        setSenhaCorreta(true);
        if (value != usuario.senha) {
            setSenhaCorreta(false);
        }
    }

    const removerMascaraTelefone = () => {
        if (usuario?.telefone.includes("(")) {
            usuario.telefone = services.mask.unMask(usuario?.telefone);
        }
    }

    const msgSenha = () => {
        if (isFormInvalid && usuario?.senha.length < 8) {
            return 'Mínimo 8 dígitos e conter números, letras maiúsculas, minúsculas e caractere especial. Ex:Senh@123';
        } else if (!senhaFormatoCorreto) {
            return "Mínimo 8 dígitos e conter números, letras maiúsculas, minúsculas e caractere especial. Ex:Senh@123"
        }
    }

    return (
        <div>
            <div className='row mt-1'>
                <span className="col-sm-12 col-md-12 col-lg-12 titulo">Usuários</span>
                <h1 className='col-sm-12 col-md-12 col-lg-12 sub-titulo'>Detalhe</h1>
            </div>

            <div className='row mt20'>
                <h1 className='col-sm-12 col-md-12 col-lg-12 label-second'>Dados de Acesso</h1>
            </div>

            <div className="row mt20">
                <div className='col-md-6'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Nome"
                            size="small"
                            onChange={event => changeUsuario(event.target.value, 'nome')}
                            value={usuario?.nome || ''}
                            helperText={isFormInvalid && !usuario?.nome && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.nome ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-4'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="E-mail"
                            size="small"
                            onChange={event => changeUsuario(event.target.value, 'email')}
                            value={usuario?.email || ''}
                            helperText={isFormInvalid && !usuario?.email && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.email ? true : false} />
                    </FormControl>
                </div>
                <div className="col-sm-2 col-md-2 col-lg-2">  <FormControl >

                    <InputLabel id="demo-simple-select-helper-label">Cargo</InputLabel>
                    <Select
                        required
                        className="select"
                        variant="outlined"
                        value={usuario?.cargo || 'selecione'}
                        label="Cargo"
                        onChange={event => changeUsuario(event.target.value, 'cargo')}
                        MenuProps={MenuProps}
                    >
                        <MenuItem disabled={true} value={"selecione"}>
                            <em>Cargo</em>
                        </MenuItem>

                        {cargos.map(cargo =>
                            <MenuItem value={cargo}>{cargo}</MenuItem>
                        )}
                    </Select>

                    {isFormInvalid && !usuario?.cargo &&
                        <FormHelperText>Campo obrigatório</FormHelperText>
                    }
                </FormControl></div>
            </div>
            <div className="row">
                <div className='col-md-3'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Celular"
                            size="small"
                            inputProps={{ maxLength: 15 }}
                            onChange={event => changeUsuario(services.mask.phoneoucelularuser(event.target.value), 'telefone')}
                            value={services.mask.phoneoucelularuser(usuario?.telefone) || ''}
                            helperText={isFormInvalid && !usuario?.telefone && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.telefone ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-3'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Senha"
                            type="password"
                            size="small"
                            onChange={event => changeUsuario(event.target.value.trim(), 'senha')}
                            value={usuario?.senha || ''}
                            helperText={msgSenha()}
                            error={isFormInvalid && usuario?.senha.length < 8 ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-3'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Confirmar Senha"
                            type="password"
                            size="small"
                            onChange={(event) => setConfirmarSenha(event.target.value)}
                            defaultValue={''}
                            helperText={!senhaCorreta ? "A senha não esta igual" : ""}
                            error={!senhaCorreta || isFormInvalid ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-3'>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Receber Notificações</FormLabel>
                        <RadioGroup className="radio-notify" value={usuario.receberNotificacao ? "sim" : "nao"} row aria-label="notificacoes" name="row-radio-buttons-group">
                            <FormControlLabel onChange={() => changeUsuario(true, 'receberNotificacao')} value={usuario.receberNotificacao ? "sim" : "sim"} control={<Radio />} label="Sim" />
                            <FormControlLabel onChange={() => changeUsuario(false, 'receberNotificacao')} value={!usuario.receberNotificacao ? "nao" : "nao"} control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>

            {/* <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={submitUsuarioSeller}>SALVAR</button>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={voltar}>CANCELAR</button>
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarUsuario}>INATIVAR</button>
            </div> */}

            {idUsuarioSeller &&
                <div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={() => submitUsuarioSeller()}>SALVAR</button>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar()}>CANCELAR</button>
                        {usuario?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarUsuario} >INATIVAR</button>}
                        {!usuario?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" >ATIVAR</button>}

                    </div>

                </div>}

            {!idUsuarioSeller &&
                <div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={() => submitUsuarioSeller()}>SALVAR</button>
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar()}>CANCELAR</button>
                    </div>

                </div>}
        </div>
    );
}

export default PerfilSellerFormUsuario;